export const FILE_ICONS_BY_EXTENSION: Record<string, string> = {
    pdf: 'document-pdf',
    doc: 'document-docx',
    docx: 'document-docx',
    xls: 'document-xls',
    xlsx: 'document-xls',
    csv: 'document-xls',
    ppt: 'document-ppt',
    pptx: 'document-ppt',
    txt: 'document-txt',
    zip: 'document-zip',
    png: 'picture',
    jpg: 'picture',
    jpeg: 'picture',
    gif: 'picture',
    bmp: 'picture',
    tif: 'picture',
    tiff: 'picture'
};
